/**
 * Admin app shell — portal-style layout: sidebar + main + sticky footer,
 * with the entire window pinned to viewport height so content scrolls
 * inside main rather than the page itself.
 *
 * Mirrors the overflow pattern from apps/portal/src/components/layout/Layout.tsx
 * but stripped of portal-only concerns (mobile header, floating feedback
 * button, feedback dialog, theme switcher).
 */

import React from 'react';
import { Toaster } from '@vehix/portal/components/ui/toaster';
import { AppFooter, type FooterLink } from '@vehix/portal/components/layout/AppFooter';
import { AdminSidebar } from './AdminSidebar';

const ADMIN_FOOTER_LINKS: FooterLink[] = [
  { label: 'User Guide', href: 'https://portal.vehix.ai/docs', external: true },
  { label: 'API Docs', href: '/api-docs' }
];

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className='h-screen bg-background text-foreground flex flex-col overflow-hidden'>
      <div className='flex flex-1 overflow-hidden'>
        <AdminSidebar />
        <main className='flex-1 w-full flex flex-col overflow-hidden'>
          <div className='flex-1 min-h-0 overflow-y-auto overflow-x-hidden flex flex-col'>
            <div className='flex-1 min-h-0 flex flex-col'>{children}</div>
          </div>
          <AppFooter sticky links={ADMIN_FOOTER_LINKS} className='flex-shrink-0' />
        </main>
      </div>
      <Toaster />
    </div>
  );
};
